import React from "react";
import {useTranslation} from "next-i18next";
import Input from "../../../search/input";
import Percentage from "../../../form/input/percentage";

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function Inputs ({ nutrient, addNutrientCallback, removeNutrientCallback, more })
{
    // init
    const { t } = useTranslation();

    /**
     *
     * @param event
     */
    function addNutrient(event) {
        addNutrientCallback(event);
    }

    /**
     *
     * @param event
     */
    function removeNutrient(event) {
        removeNutrientCallback(event);
    }

    // render
    return (
        <>
            <div className="row justify-content-center justify-content-lg-start">
                {/* Name */}
                <div className="position-relative col-7 col-sm-7 col-md-6 col-lg-5 col-xl-4 mb-3">
                    <Input
                        type={'nutrient'}
                        defaultValue={nutrient.translation ?? nutrient.name}
                        multiple={true}
                        placeholder={t('nutrient')}
                        name={null}
                        required={false}
                        loadOnChoose={false}
                    />
                </div>

                {/* Percentage */}
                <div className="col-3 col-sm-3 col-md-2 mb-3">
                    <Percentage
                        name={'nutrients_percentage[]'}
                        value={nutrient.proportion}
                        required={false}
                    />
                </div>

                {/* More or less */}
                <div className="col-2 col-sm-2 col-md-1 mb-3">
                    <button data-eqno-nutrient-id={nutrient.id} onClick={more ? addNutrient : removeNutrient} className={"form-control btn fw-bolder ps-0 pe-0" + (more ? ' btn-outline-primary' : ' btn-outline-danger')} type="button">
                        {more ? '+' : '-'}
                    </button>
                </div>
            </div>
        </>
    );
}